import {defaultTheme} from "react-select";
import {useTranslation} from "react-i18next";
import React from "react";
import {useSelector} from "react-redux";

export const {colors} = defaultTheme;
export const FormatLabel = (props) => {
  const currentSelectedContract = useSelector((state) => state.contracts.currentContractSelected);
  const {t} = useTranslation();
  return (
    <div className={currentSelectedContract?.id === props?.id ? "selected-contract" : null}
    >
      { props.id !== '0' ? (<> <span className={"mr-3 font-bold badge badge--" + props.state}>
        {t(`contract.select.state.${props.state}`)}
      </span>
      <span className="button-text">{props.name}</span>

      </>) : (
      <>
      <span className="button-text">{t(`common.documentType.all`)}</span>
      </>
      )
      }
    </div>
  );
};
export const formatOptionLabel = ({name, id: value, state}) => {
  return (
      <FormatLabel name={name} state={state} id={value}/>
  );
};
export const Menu = (props) => {
  const shadow = "hsla(218, 50%, 10%, 0.1)";
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 5,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: "absolute",
        zIndex: 2,
        width: "100%",
      }}
      {...props}
    />
  );
};
export const Blanket = (props) => {
  return (
    <div
      style={{
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
        position: "fixed",
        zIndex: 1,
      }}
      {...props}
    />
  )
};
export const Dropdown = ({children, isOpen, target, onClose}) => {
  return (
    <div style={{position: "relative"}}>
      {target}
      {isOpen ? <Menu>{children}</Menu> : null}
      {isOpen ? <Blanket onClick={onClose}/> : null}
    </div>
  )
};
export const Svg = (p) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      focusable="false"
      role="presentation"
      {...p}
    />
  )
};
export const DropdownIndicator = () => {
  return (
    <div style={{color: colors.neutral20, height: 24, width: 32}}>
      <Svg>
        <path
          d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </Svg>
    </div>
  )
};
